import type { Threshold, NumericDomain } from "@incytestudios/ddv";
import type { GasCurveChartContext } from "./d";

export const getPumpThresholds = (context: GasCurveChartContext) => {
  const { ascendingOrderPumps } = context;
  return ascendingOrderPumps.map<Threshold>((xrefPump, i) => {
    const previousStages = ascendingOrderPumps
      .slice(0, i)
      .reduce(
        (sum, previousXrefPump) =>
          previousXrefPump.total_stages
            ? (sum += previousXrefPump.total_stages)
            : sum,
        0
      );

    return {
      label: xrefPump.r_pump?.series_model || "",
      color: `var(--plotColor${i})`,
      value: {
        min: previousStages,
        max: previousStages + (xrefPump.total_stages || 1)
      } as NumericDomain
    };
  });
};
